import React from 'react';
import { kebabCase } from 'lodash';
import { useField } from 'formik';
import { Input } from 'syngenta-digital-cropwise-react-ui-kit';
import { FieldLabel, FieldMessage } from './FieldChrome';
import useFieldMessage from './useFieldMessage';
import './disabledFields.css';

type FormikTextAreaProps = {
  name: string;
  id?: string;
  label?: React.ReactNode;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  style?: React.CSSProperties;
  errorMessage?: string | null;
};

const FormikTextArea = ({
  name,
  id,
  label,
  className = '',
  errorMessage,
  ...rest
}: FormikTextAreaProps) => {
  const [field, , { setTouched, setValue }] = useField(name);
  const { hasError, message } = useFieldMessage(name, errorMessage);
  const inputId = id ?? kebabCase(name);

  return (
    <div>
      {label && <FieldLabel htmlFor={inputId}>{label}</FieldLabel>}
      <Input.TextArea
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...rest}
        id={inputId}
        name={name}
        className={`w-full cwf-kit-field ${className}`}
        value={field.value ?? ''}
        onChange={field.onChange}
        onBlur={(event: React.FocusEvent<HTMLTextAreaElement>) => {
          setTouched(true);
          setValue(event.target.value);
        }}
        status={hasError ? 'error' : undefined}
      />
      <FieldMessage message={message} />
    </div>
  );
};

export default FormikTextArea;
